import { render, staticRenderFns } from "./DVipEditor.vue?vue&type=template&id=4f328c9e&"
import script from "./DVipEditor.vue?vue&type=script&lang=js&"
export * from "./DVipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports